export function transformWaitMusic(waitMusic) {
    waitMusic.id = waitMusic.uuid;
    delete waitMusic.uuid;
    return waitMusic;
}
